// import { SortType } from '@/types/common';
import { Obj } from '@/types/common';

export function filterReqData<T extends Obj>(data: T): T {
  if (data) {
    const dataCopy = JSON.parse(JSON.stringify(data));
    const map = new Map<keyof T, any>();
    Object.entries(dataCopy).forEach(([key, val]) => map.set(key, val));
    for (let [key, value] of Array.from(map.entries())) {
      if (!value && value !== false && value !== 0) map.delete(key);
      else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          value.forEach((item, i) => {
            if (!item && item !== false && item !== 0) value.splice(i, 1);
            else if (typeof item === 'object') {
              item = filterReqData(item);
              value[i] = item;
            }
          });
          map.set(key, value);
        } else {
          if (!Object.keys(value).length) map.delete(key);
          else {
            value = filterReqData(value);
            Object.keys(value).length ? map.set(key, value) : map.delete(key);
          }
        }
      }
    }
    return Object.fromEntries(map) as T;
  }
  return data;
}

export const getQueryString = (
  // data: Record<string, string | number | undefined | null | SortType>
  data: Record<string, string | number | undefined | null>
) => {
  return Object.entries(filterReqData({ ...data }))
    .map(([key, val]) => `${key}=${String(val)}`)
    .join('&');
};
